<template>
    <app-layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Account">
        <template #header>
            <h2 class="text-1xl md:text-2xl font-semibold transition duration-500 ease-in-out text-white sm:text-gray-600 sm:dark:text-white col-span-1 md:col-span-2">
                Account
            </h2>
        </template>
        <div>
            <div class="max-w-7xl mx-auto pt-10 sm:px-6 lg:px-8">
                <div v-if="$page.props.user.can_refer">
                    <referrals :user="$page.props.user" :referrals="referrals" />
                    <jet-section-border />
                </div>
            </div>
            <div class="max-w-7xl mx-auto pt-10 sm:px-6 lg:px-8">
                <div v-if="$page.props.racingstars.canViewBalanceInformation">
                    <balance-information :user="$page.props.user" />
                    <jet-section-border />
                </div>
            </div>
            <div class="max-w-7xl mx-auto pt-10 sm:px-6 lg:px-8">
                <div>
                    <bets :races="races" :user="$page.props.user" />
                    <jet-section-border />
                </div>
            </div>
            <div class="max-w-7xl mx-auto pt-10 sm:px-6 lg:px-8">
                <div>
                    <payments :user="$page.props.user" />
                    <jet-section-border />
                </div>
            </div>
            <div class="max-w-7xl mx-auto pt-10 sm:px-6 lg:px-8">
                <div>
                    <subscriptions :available-subscriptions="$page.props.user.available_subscriptions" :subscriptions="$page.props.user.subscriptions" />
                    <jet-section-border />
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
import AppLayout from '@/Layouts/Layout.vue'
import JetSectionBorder from '@/Jetstream/SectionBorder.vue'
import Referrals from '@/Pages/Account/Partials/Referrals.vue'
import BalanceInformation from '@/Pages/Account/Partials/BalanceInformation.vue'
import Bets from '@/Pages/Account/Partials/Bets.vue'
import Payments from '@/Pages/Account/Partials/Payments.vue'
import Subscriptions from '@/Pages/Account/Partials/Subscriptions.vue'

export default {
    props: ['sessions', 'races', 'referrals'],

    components: {
        AppLayout,
        JetSectionBorder,
        Referrals,
        BalanceInformation,
        Bets,
        Payments,
        Subscriptions,
    },
}

</script>
